'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _PartialTable = require('./PartialTable');

var _PartialTable2 = _interopRequireDefault(_PartialTable);

var _actions = require('./actions');

var _selectors = require('./selectors');

var _utils = require('./utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultFilters = {
  globalSearch: { filter: _utils.containsIgnoreCase }
};

var DataTable = function (_Component) {
  _inherits(DataTable, _Component);

  function DataTable() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DataTable);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call.apply(_ref, [this].concat(args))), _this), _this.init = function (nextProps) {
      if (!nextProps || !nextProps.initialized) {
        _this.props.initialize(_this.props.initialData);
      }
    }, _this.onFilter = function (key, _ref2) {
      var value = _ref2.target.value;
      return _this.props.filter(key, value);
    }, _this.onSort = function (value) {
      return _this.props.sort(value);
    }, _this.onPageSizeChange = function (_ref3) {
      var value = _ref3.target.value;
      return _this.props.changePageSize(value);
    }, _this.onPageNumberChange = function (value) {
      return _this.props.changePageNumber(value);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DataTable, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.init();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      this.init(nextProps);
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_PartialTable2.default, _extends({
        onFilter: this.onFilter,
        onSort: this.onSort,
        onPageSizeChange: this.onPageSizeChange,
        onPageNumberChange: this.onPageNumberChange
      }, this.props));
    }
  }]);

  return DataTable;
}(_react.Component);

DataTable.propTypes = {
  table: _react.PropTypes.string.isRequired
};

var mapStateToProps = function mapStateToProps(state, props) {
  var buildRowOptions = props.buildRowOptions,
      columns = props.columns,
      initialData = props.initialData,
      keys = props.keys,
      pageLengthOptions = props.pageLengthOptions,
      table = props.table;


  var data = (0, _selectors.selectDataTable)(table)(state);
  var initialized = data && data.initialized;

  return {
    buildRowOptions: buildRowOptions,
    columns: columns,
    data: data,
    initialData: initialData,
    initialized: initialized,
    keys: keys,
    pageLengthOptions: pageLengthOptions
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  var filters = ownProps.filter || defaultFilters;
  var table = ownProps.table;


  return {
    changePageNumber: function changePageNumber(pageNumber) {
      return dispatch((0, _actions.pageNumberChange)(pageNumber, table));
    },
    changePageSize: function changePageSize(pageSize) {
      return dispatch((0, _actions.pageSizeChange)(pageSize, table));
    },
    initialize: function initialize(initialData) {
      return dispatch((0, _actions.initialize)(initialData, table));
    },
    filter: function filter(key, value) {
      return dispatch((0, _actions.dataFilter)(key, value, filters, table));
    }
  };
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(DataTable);


//////////////////
// WEBPACK FOOTER
// ./~/react-data-components/lib/ReduxTable.js
// module id = 789
// module chunks = 0